import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';
import { message } from 'antd';
import { wechatGenerateScheme } from '../../api';
import { debounce } from '../../utils/common';
import './style.scss';

const pics = [
  'https://staticfile.badazhou.com/20251203/25c597f1c8b9afbb0346e3c70999e2a0.jpeg',
  'https://staticfile.badazhou.com/20251203/c2401b8a9e10ddd7621cc1d56547833b.jpeg',
  'https://staticfile.badazhou.com/20251203/9a765abf1d02c984d8e2699c1df30242.jpeg',
  'https://staticfile.badazhou.com/20251203/f62d6d48e020bafb82727462d07c657a.jpeg',
  'https://staticfile.badazhou.com/20251203/42616e26213f2aed95f4e3dd467c0896.jpeg',
  'https://staticfile.badazhou.com/20251203/9069ab9a9beb2d71b99781ff131cce22.jpeg',
  'https://staticfile.badazhou.com/20251203/57fd941f7d688498719283bc15a87b65.jpeg',
  'https://staticfile.badazhou.com/20251203/ab6a587bfab28a987beb752a27f50611.jpeg',
];

const merchantNo = 'sA3wbNzkmGjr';

const Audi = () => {
  const { search } = useLocation();

  // 格式化手机号：如果没有区号，默认添加86-
  const formatPhone = (phone) => {
    if (!phone) return '';

    // 如果已经包含区号格式（如 86-13800138000）
    if (phone.includes('-')) {
      return phone;
    }

    // 如果没有区号，默认添加86-
    return `86-${phone}`;
  };

  // 校验手机号和会员等级（手机号可选）
  const validateParams = (phone, level) => {
    // 手机号校验：如果有手机号，则校验格式
    let isValidPhone = true;
    if (phone) {
      let phoneNumber = phone;

      // 如果包含区号格式（如 86-13800138000），提取手机号部分
      if (phone.includes('-')) {
        const parts = phone.split('-');
        if (parts.length === 2) {
          phoneNumber = parts[1];
        } else {
          isValidPhone = false;
        }
      }

      // 手机号校验：11位数字，以1开头
      if (isValidPhone) {
        const phoneRegex = /^1[3-9]\d{9}$/;
        isValidPhone = phoneRegex.test(phoneNumber);
      }
    }

    // 会员等级校验：只能是1、2、3（必传）
    const isValidLevel = level && ['1', '2', '3'].includes(level.toString().trim());

    return isValidPhone && isValidLevel;
  };

  // 创建防抖函数（500ms防抖）
  const debouncedHandleClick = useMemo(() => {
    const handleImageClick = () => {
      // 获取参数并校验
      const parseUrl = parse(search);
      const phoneParam = parseUrl.phone || '';
      const levelParam = parseUrl.level || '';
      const valid = validateParams(phoneParam, levelParam);

      if (!valid) {
        if (phoneParam) {
          message.error('参数校验失败，请检查手机号和会员等级是否正确');
        } else {
          message.error('参数校验失败，请检查会员等级是否正确（level只能是1、2、3）');
        }
        return;
      }

      // 格式化手机号：如果有手机号，格式化后添加；如果没有，不添加
      const formattedPhone = phoneParam ? formatPhone(phoneParam) : '';

      // 生成跳转scheme，query包含merchantNo、level，如果有手机号则加上phone
      const path = '/pages/myCenter/myCenter';
      const randomNum = parseInt(Math.random() * 100000000);
      let query = `merchantNo=${merchantNo}&level=${levelParam}&randomNum=${randomNum}`;
      if (formattedPhone) {
        query += `&phone=${encodeURIComponent(formattedPhone)}`;
      }

      wechatGenerateScheme({ path, query }).then((res) => {
        if (res.data && res.data.scheme) {
          window.location.href = res.data.scheme;
        }
      }).catch((err) => {
        console.error('生成跳转scheme失败:', err);
        message.error('跳转失败，请稍后重试');
      });
    };

    return debounce(handleImageClick, 500);
  }, [search]);

  return (
    <div className="audi-container">
      {pics.map((pic, index) => (
        <img
          key={index}
          src={pic}
          alt={`pic-${index + 1}`}
          className={`audi-img img-${index + 1} ${index === 2 ? 'clickable' : ''}`}
          onClick={index === 4 ? debouncedHandleClick : undefined}
        />
      ))}
    </div>
  );
};

export default Audi;
